import { TextKey } from '@mews-commander/enums';
import { SecurityCard } from '../SecurityCard';
import { usePasswordGatedDialog } from '../VerifyPasswordDialog';
import { CHANGE_PASSWORD_DIALOG_NAME, ChangePasswordDialog } from './ChangePasswordDialog';

export const ChangePasswordSettings = () => {
    const openPasswordGatedDialog = usePasswordGatedDialog();

    return (
        <SecurityCard
            onClick={() =>
                openPasswordGatedDialog(
                    ChangePasswordDialog,
                    CHANGE_PASSWORD_DIALOG_NAME,
                    TextKey.ChangePasswordPasswordGate
                )
            }
            primaryText={TextKey.Password}
            secondaryText={TextKey.ChangeYourPassword}
        />
    );
};
